import { useState,useEffect } from 'react'
import Dialog from '../../GenericComponents/dialog'
import {
    useCheckEditSaveMutation,
    useEditSaveVUMutation,
} from '../../Redux/ReportActions/reportActionsSlice'
import { VUSettingsDialog } from './VUSettingsDialog'
import { IVuParams } from '../../Redux/VisualUnits/visualUnitStateSlice'
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit'
import { VisualUnitApiDTO_VisualUnit_Extended } from '../../Interfaces/VisualUnit/VisualUnitApiDTO_VisualUnit'

interface VuSettingsProps {
    isExplore: boolean
    setisExplore: (value: boolean) => void  
    iseditSettingsDialogOpen: boolean
    setiseditSettingsDialogOpen: (value: boolean) => void
    setReport: (value: VisualUnitApiDTO_VisualUnit_Extended) => void
    report: VisualUnitApiDTO_VisualUnit
    workspaceId: number
    drillThruDPList: any[]
    vuParams: IVuParams[]
    setIsRedrawVU?: (value: boolean) => void
    setTempVuData: (value: VisualUnitApiDTO_VisualUnit_Extended) => void
    isUpdateFromSettings: React.MutableRefObject<boolean>;
    isSaveClicked: React.MutableRefObject<boolean>;
    actionType?: string;
    saveVUdataChanges: boolean;
    setsaveVUdataChanges: (value: boolean) => void;
    shouldcallCheckeditsave: boolean;
    setupVU: (value: any) => void;
}

export const VuSettings = (props: VuSettingsProps) => {
    const {
        isExplore,
        setisExplore,
        iseditSettingsDialogOpen,
        setiseditSettingsDialogOpen,
        setReport,
        report,
        workspaceId,
        drillThruDPList,
        vuParams,
        // setIsRedrawVU,
        setTempVuData,
        isUpdateFromSettings,
        isSaveClicked,
        actionType,
        saveVUdataChanges,
        setsaveVUdataChanges,
        shouldcallCheckeditsave,
        setupVU

        
    } = props
    const [CheckEditSaveResponse, setCheckEditSaveResponse] = useState<any>(null)
    const [usersUsingVUs, setusersUsingVUs] = useState(0)
    const [roleNames, setRoleNames] = useState<string[]>([])
    const [dashBoardsUsingVUs, setdashBoardsUsingVUs] = useState(0)
    const [editSettingsformData, seteditSettingsformData] = useState({
        name: report.Name || '',
        description: report.Description || '',
        autoRefresh: report.RefreshInterval + '' || '0',
        privacyLock: report.PrivacyLock || '0',
        allowDrillThru: report.AllowDrillThru || 'Y',
        drillThruPageSize: report.DrillthruPageSize + '' || '10',
        autoNext: report.IsEnabledAutoNavigation || false,
    })
    const [showpageSizeOption, setShowPageSizeOption] = useState<boolean>(report.AllowDrillThru === 'Y')
    useEffect(() => {
        if(!iseditSettingsDialogOpen && !saveVUdataChanges){
        seteditSettingsformData({
            name: report?.Name || '',
            description: report?.Description || '',
            autoRefresh: report?.RefreshInterval + '' || '0',
            privacyLock: report?.PrivacyLock || '0',
            allowDrillThru: report?.AllowDrillThru || 'Y',
            drillThruPageSize: report?.DrillthruPageSize + '' || '10',
            autoNext: report?.IsEnabledAutoNavigation || false,
        })
    }
    }, [report])
 
    const handleChange = (field: string, value: any) => {        
        seteditSettingsformData((prevState) => ({
            ...prevState,
            [field]: value,
        }))
    }

    const handleCancel = () => {
        seteditSettingsformData({
            name: report?.Name || '',
            description: report?.Description || '',
            autoRefresh: report?.RefreshInterval + '' || '0',
            privacyLock: report?.PrivacyLock || '0',
            allowDrillThru: report?.AllowDrillThru || 'Y',
            drillThruPageSize: report?.DrillthruPageSize + '' || '10',
            autoNext: report?.IsEnabledAutoNavigation || false,
        })
    }
    const [callcheckEditSaveAPI] = useCheckEditSaveMutation()
    const handledropdownChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const { name, value } = event.target // Extract name and value from the event
        seteditSettingsformData((prevState) => ({        
            ...prevState,
            [name]: value, // Dynamically update the corresponding field in editSettingsformData
        }))
        if (name === 'allowDrillThru') {
            setShowPageSizeOption(value === 'Y')
        }
    }

    useEffect (() => {
        if (shouldcallCheckeditsave)
        {
            handleCheckEditSave(report.VisualUnitId, workspaceId, "");
        }
    }, [shouldcallCheckeditsave]);

    const handleCheckEditSave = (
        VisualUnitId: number,
        DashboardId: number,
        DashboardName: string
    ) => {
        callcheckEditSaveAPI({ VisualUnitId, DashboardId, DashboardName })
            .unwrap()
            .then((response) => {
                if (response) {
                    setiseditSettingsDialogOpen(!iseditSettingsDialogOpen)
                    setsaveVUdataChanges(true)
                    setCheckEditSaveResponse(response.data)
                    setusersUsingVUs(response.data?.usersUsingVUs)
                    setRoleNames(response.data?.roleNames)
                    setdashBoardsUsingVUs(response.data?.dashBoardsCount)
                    // Log the response
                }
            })
            .catch((error) => {
                console.error('Error during API call:', error)
            })
    }
    return (
        <>
            <Dialog
                isOpen={Boolean(iseditSettingsDialogOpen && actionType && (actionType === "addNewVU" || actionType === "copyVU"))}
                onClose={() => setiseditSettingsDialogOpen(false)} // Close dialog
                className="ui-front ui-dialog-buttons"
                title="Save Report"
                width={'480px'}
                buttons={[
                    {
                      label: "Cancel",
                      id: "cancelEditSettings",
                      onClick: () => {setiseditSettingsDialogOpen(false);
                      handleCancel();                      
                      },
                      className: "ui-button ui-corner-all ui-widget app-button negative",
                    },
                    {
                      label: "Save Changes",
                      id: "saveEditSettings",
                      onClick: () => {
                        setiseditSettingsDialogOpen(false);
                        handleCheckEditSave(report.VisualUnitId, workspaceId, "");
                      },
                      className: "ui-button ui-corner-all ui-widget app-button",
                    },
                ]}
            >
                <div
                    id="vu_details_dialog_wrapper"
                    style={{
                        display: 'block',
                        width: 'auto',
                        minHeight: '43.6px',
                        height: 'auto',
                    }}
                >
                    <table className="input-form-table-popup-window vu-details-content">
                        <tbody>
                            <tr>
                                <td className="left" style={{ width: '25%' }}>
                                    Name:
                                </td>
                                <td className="right">
                                    <input
                                        name="name"
                                        className="field-name"
                                        type="text"
                                        size={40}
                                        maxLength={100}
                                        value={editSettingsformData.name}
                                        onChange={(e) => handleChange('name', e.target.value)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="left">
                                    <div>Description:</div>
                                    <div className="field-optional">(optional)</div>
                                </td>
                                <td className="right">
                                    <textarea
                                        name="description"
                                        className="field-desc"
                                        rows={6}
                                        cols={40}
                                        maxLength={255}
                                        placeholder="Please add a description here for other users (Maximum 255 Characters)"
                                        value={editSettingsformData.description}
                                        onChange={(e) =>
                                            handleChange('description', e.target.value)
                                        }
                                    ></textarea>
                                </td>
                            </tr>
                            <tr>
                                <td className="left">Auto Refresh:</td>
                                <td className="right">
                                    <select
                                        name="autoRefresh"
                                        className="field-auto-refresh"
                                        value={'' + editSettingsformData.autoRefresh}
                                        onChange={handledropdownChange}
                                        // onChange={(e) => handleChange("refreshInterval", e.target.value)}
                                    >
                                        <option value="0">- no -</option>
                                        <option value="1">every 1 minute</option>
                                        <option value="5">every 5 minutes</option>
                                        <option value="10">every 10 minutes</option>
                                        <option value="15">every 15 minutes</option>
                                        <option value="30">every 30 minutes</option>
                                        <option value="45">every 45 minutes</option>
                                        <option value="60">every 60 minutes</option>
                                    </select>
                                </td>
                            </tr>
                            <tr id="visual_unit_privacy_lock">
                                <td className="left">Access Level:</td>
                                <td className="right">
                                    <select
                                        name="privacyLock"
                                        className="field-auto-refresh"
                                        value={editSettingsformData.privacyLock}
                                        onChange={handledropdownChange}
                                    >
                                        <option value="0">Open, changes allowed</option>
                                        <option value="2">
                                            Locked, only for me and administrators
                                        </option>
                                    </select>
                                </td>
                            </tr>
                            <tr id="visual_unit_allow_drillthru">
                                <td className="left">Allow Drill thru:</td>
                                <td className="right">
                                    <select
                                        name="allowDrillThru"
                                        className="field-auto-refresh"
                                        value={editSettingsformData.allowDrillThru}
                                        onChange={handledropdownChange}
                                    >
                                        <option value="Y">Yes, Allow Drill Thru</option>
                                        <option value="N">No, Disable Drill Thru</option>
                                    </select>
                                </td>
                            </tr>
                            {showpageSizeOption &&
                                <tr id="visual_unit_drillthru_page_size">
                                    <td className="left">Drillthru Page Size:</td>
                                    <td className="right">
                                        <select
                                            name="drillThruPageSize"
                                            className="field-auto-refresh"
                                            value={editSettingsformData.drillThruPageSize}
                                            onChange={handledropdownChange}
                                        >
                                            <option value="10">10 Rows</option>
                                            <option value="20">20 Rows</option>
                                            <option value="30">30 Rows</option>
                                        </select>
                                    </td>
                                </tr>
                            }
                            <tr id="visual_unit_auto_next">
                                <td className="left">Auto Next:</td>
                                <td className="right">
                                    <input
                                        type="checkbox"
                                        name="autoNext"
                                        checked={editSettingsformData.autoNext}
                                        onChange={(e) => handleChange('autoNext', e.target.checked)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="left"></td>
                                <td className="right"></td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    <span
                                        style={{
                                            whiteSpace: 'normal',
                                            fontSize: 'x-small',
                                            color: 'red',
                                        }}
                                        id="verify_default_drillthruset_as_warning"
                                    >
                                        - Please verify your drillthru/detailed view and
                                        configurations after the report is saved.
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Dialog>
            <VUSettingsDialog
                 isExplore={isExplore}
                setisExplore={setisExplore}
                report={report}
                saveVUdataChanges={saveVUdataChanges}
                setsaveVUdataChanges={setsaveVUdataChanges}
                editSettingsformData={editSettingsformData}
                workspaceId={workspaceId}
                drillThruDPList={drillThruDPList}
                CheckEditSaveResponse={CheckEditSaveResponse}
                usersUsingVUs={usersUsingVUs}
                dashBoardsUsingVUs={dashBoardsUsingVUs}
                roleNames={roleNames}
                vuParams={vuParams}
                resetForm={handleCancel}
                setReport={setReport}
                // setIsRedrawVU={setIsRedrawVU}
                setTempVuData={setTempVuData}
                isUpdateFromSettings={isUpdateFromSettings}
                isSaveClicked={isSaveClicked}  
                actionType={actionType} 
                setupVU={setupVU}
            />
        </>
    )
}
